<template>
	<div>
		<div class="unit-box" :class="{'z-dis': !editable}" :style="{'z-index': top ? '0' : 'auto', 'width': full ? 'auto' : '1400px'}" @dblclick="unitEdit">
			<div class="unit-content">
				<slot></slot>
			</div>
			<div class="unit-tool flex-center-cross" @dblclick.stop>
				<a v-if="index > 1" @click="sortHandle(-1)"><i class="sf sf-sort-up"></i></a>
				<a v-if="after && after.load_type != 2" @click="sortHandle(1)"><i class="sf sf-sort-down"></i></a>
				<button v-if="deleteButton" @click="removeHandle">删除</button>
				<sub-switch v-if="switchButton" :value="active" text="显示,隐藏" @change="changeHandle"></sub-switch>
			</div>
		</div>
		
		<sub-dialog v-if="config && editState" ref="edit" :fadein="code == 'code'" :title="name" :width="code == 'code' ? 1000 : 500" :height="code == 'code' ? 450 : 'auto'" @resolve="submitHandle" @close="editFinish">
			<ul class="unit-edit-tab flex">
				<li v-for="(item, i) in config" :key="i" :class="{'z-crt': currentTab == i}" @click="currentTab = i">{{item.tab}}</li>
			</ul>
			<div v-show="currentTab == i" v-for="(item, i) in config" :key="i" class="unit-edit-content">
				<p v-if="item.tips" class="unit-edit-tips">{{item.tips}}</p>
				<unit-edit-form ref="form" :config="item.content"></unit-edit-form>
			</div>
		</sub-dialog>
		
		<product-selector ref="productSelector"></product-selector>
	</div>
</template>

<script>
	import unitEditForm from './unit_edit_form.vue'
	import productSelector from './product_selector.vue'
	import subPcConfig from './unit_edit_config_pc.js'
	import subAppConfig from './unit_edit_config_app.js'
	import sysPcConfig from '@/components/decorate/unit_edit_config_pc.js'
	import sysAppConfig from '@/components/decorate/unit_edit_config_app.js'
	
	const appConfig = Object.assign(subAppConfig, sysAppConfig);
	const pcConfig = Object.assign(subPcConfig, sysPcConfig);
	
	export default {
		name: 'unitEdit',
		
		components: {
			unitEditForm,
			productSelector
		},
		
		props: {
			type: String,
			top: Boolean,
			index: Number,
			name: String,
			uid: Number,
			code: String,
			handle: Boolean,
			editable: Boolean,
			switchButton: Boolean,
			deleteButton: Boolean,
			active: Boolean,
			after: Object,
			auth: {
				type: Boolean,
				default: true
			}
		},
		
		data() {
			let config = (this.type == 'app' ? appConfig[this.code] : pcConfig[this.code]) || [];
			if (this.auth && this.sub.decorate.unitAuth && !['waterfall_flow', 'channel_product'].includes(this.code)) {
				config = config.map(item => item);
				config.push({
					tab: '权限设置',
					content: [{
						label: '可见用户',
						type: 'checkbox',
						code: 'user_type',
						options: this.sub.decorate.unitAuth
					}]
				})
			}
			return {
				full: this.type == 'app' || ['banner', 'channel_banner', 'channel_image_list', 'code'].includes(this.code),
				config,
				editState: false,
				currentTab: 0
			}
		},
		
		mounted() {
			this.updateUnitData();
		},
		
		methods: {
			updateUnitData() {
				this.request({
					url: '/decoration/page/control/data',
					data: {
						page_control_id: this.uid
					},
					success: data => {
						let $unit = this.$children[0].$children[0];
						if ($unit) {
							$unit.set ? $unit.set(data.control_data) : $unit.unitData = data.control_data;
						}
					}
				});
			},
			
			unitEdit() {
				if (!this.editable) return;
				this.currentTab = 0;
				this.editState = true;
				this.$nextTick(() => {
					this.request({
						url: '/decoration/page/control/config/detail',
						data: {
							page_control_id: this.uid
						},
						loading: true,
						success: data => {
							data = JSON.parse(data.control_configure || '{}');
							this.$refs.edit.open();
							this.$refs.form.forEach(item => {
								item._backfill = true;
								item.set(data);
							});
						}
					});
				});
			},
			
			sortHandle(step) {
				this.request({
					url: '/decoration/control/sort',
					data: {
						page_control_id: this.uid,
						new_sort_id: this.index + step
					},
					success: () => {
						this.$bus.$emit('updateUnitList');
					}
				})
			},
			
			removeHandle() {
				this.sub.$confirm({
					text: '确定要删除此控件吗？',
					resolve: () => {
						this.request({
							url: '/decoration/control/remove',
							data: {
								page_control_id: this.uid
							},
							loading: true,
							success: () => {
								this.$bus.$emit('updateUnitList');
							}
						})
					}
				})
			},
			
			changeHandle(state, stop, next) {
				stop();
				this.request({
					url: '/decoration/page/control/state/edit',
					data: {
						page_control_id: this.uid,
						state: this.active ? 0 : 1
					},
					success: () => {
						next();
					}
				})
			},
			
			submitHandle: async function(stop, next) {
				stop();
				let data = {};
				for (let i = 0; i < this.$refs.form.length; i++) {
					let temp = await this.$refs.form[i].submit();
					data = Object.assign(data, temp);
				};
				this.request({
					url: '/decoration/page/control/config/edit',
					data: {
						page_control_id: this.uid,
						control_configure: JSON.stringify(data)
					},
					loading: true,
					success: () => {
						this.sub.$message({
							text: '保存成功'
						});
						this.updateUnitData();
						next();
					}
				});
			},
			
			editFinish() {
				setTimeout(() => {
					this.editState = false;
				}, 500);
			},
			
			selectProduct(opt) {
				this.$refs.productSelector.open(opt);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.unit {
		&-box {
			position: relative;
			min-height: 38px;
			margin: 0 auto;
			cursor: pointer;
			user-select: none;
			
			&.z-dis:hover {
				&:before {
					background: rgba(0,0,0,.5);
				}
				
				&:after {
					content: '此模块不可编辑';
					color: #FFCB00;
				}
			}
			
			&:hover {
				&:before {
					content: '';
					z-index: 11;
					position: absolute;
					inset: 0;
					border: 2px dashed #f00;
					background: rgba(154,190,208,.7);
				}
				
				&:after {
					content: '双击编辑内容';
					z-index: 11;
					position: absolute;
					left: 10px;
					top: 0;
					width: 100%;
					line-height: 38px;
					font-size: 15px;
					font-weight: bold;
					text-shadow: 2px 2px 2px rgba(0,0,0,.6);
					color: #fff;
				}
				
				.unit-tool {
					display: block;
					
					> * {
						margin-left: 10px;
					}
					
					a {
						&:hover {
							opacity: .6;
						}
					}
				}
			}
		}
		
		&-content {
			position: initial;
			
			>>> .unit-empty {
				line-height: 38px;
				text-align: center;
				color: #999;
				
				&:before {
					content: '未编辑内容';
				}
			}
		}
		
		&-tool {
			display: none;
			z-index: 12;
			position: absolute;
			right: 0;
			top: 0;
			right: 0;
			height: 30px;
			padding: 5px;
			
			button {
				height: 28px;
				padding: 0 10px;
				border-radius: 2px;
				margin-left: 6px;
				font-size: 13px;
				color: #fff;
				background: #464847;
				cursor: pointer;
				
				&:hover {
					opacity: .8;
				}
			}
		}
		
		&-edit {
			&-tab {
				z-index: 1;
				position: sticky;
				top: 0;
				height: 34px;
				border-bottom: 1px solid #ddd;
				background: #F4F4F4;
				
				li {
					height: 34px;
					border: 1px solid #ddd;
					border-width: 0 1px 1px 0;
					padding: 0 17px;
					line-height: 34px;
					cursor: pointer;
					
					&:hover {
						background: #fff;
					}
					
					&.z-crt {
						border-bottom-color: #fff;
						background: #fff;
					}
				}
			}
			
			&-tips {
				z-index: 9;
				position: sticky;
				top: 35px;
				padding: 10px 14px;
				line-height: 18px;
				font-size: 12px;
				color: #f18137;
				background: #fffcf3;
			}
		}
	}
</style>
